import { Popover } from "@base-ui-components/react";

export namespace PopoverPortal {
	export type ElementName = "Popover.Portal";
	export type ElementType = HTMLElement;
	export type Props = Popover.Portal.Props;
}

export const PopoverPortal = (componentProps: PopoverPortal.Props) => {
	const { children, ...restProps } = componentProps;

	return <Popover.Portal {...restProps}>{children}</Popover.Portal>;
};
